module.exports = __webpack_public_path__ + "static/media/solo17.91087ac5.JPG";